import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Shield } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function GuaranteeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full px-6 py-10" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-89">
          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-90">
            <Shield className="w-10 h-10 text-muted-teal" strokeWidth={1.5} data-id="element-91" />
            <h2 className="font-playfair text-3xl md:text-4xl font-bold" data-id="element-92">
              Sin riesgo. Sin dudas.
            </h2>
          </div>

          <div className="bg-muted-teal/10 border border-muted-teal/30 rounded-xl p-8 md:p-10" data-id="element-93">
            <p className="text-lg md:text-xl mb-6" data-id="element-94">Sé lo que estás pensando.</p>

            <p className="text-lg md:text-xl italic mb-8 text-warm-cream/80" data-id="element-95">
              "He probado cosas antes. He gastado dinero en soluciones que no
              funcionaron. ¿Por qué esta sería diferente?"
            </p>

            <p className="text-lg md:text-xl mb-6" data-id="element-96">
              Es una pregunta justa. Y la respondo así:
            </p>

            <p className="text-lg md:text-xl mb-6" data-id="element-97">
              Si aplicas las herramientas durante 7 días y no notas ningún
              cambio en tu ansiedad o tu sueño — quiero saberlo. Este kit está
              construido sobre mecanismos biológicos reales, no sobre esperanza.
              Funciona porque actúa sobre el hardware de tu sistema nervioso, no
              sobre las narrativas de tu mente.
            </p>

            <p className="text-lg md:text-xl mb-8" data-id="element-98">
              Pero si después de usarlo genuinamente sientes que no te aportó
              valor, simplemente escríbenos. Sin preguntas incómodas. Sin
              burocracia.
            </p>

            <p className="text-xl md:text-2xl font-playfair font-bold text-muted-teal text-center" data-id="element-99">
              La única forma de perder es no intentarlo.
            </p>
          </div>

          <CtaButton text="Empieza tu reset hoy. Acceso inmediato" subtitle="Sin riesgo — satisfacción garantizada" data-id="element-100" />
        </motion.div>
      </div>
    </section>;
}